const storageAPIExists = function (storageName) {
    if (!storageName) return;
    const prefix = storageName.substring(0, 9);
    if (prefix === 'livechat_') {
        storageName = storageName.substring(prefix.length, storageName.length);
        return (
            ApexChat.storageAPI.Exists(`apexchat_${storageName}`) ||
            ApexChat.storageAPI.Exists(`livechat_${storageName}`)
        );
    }
    return ApexChat.storageAPI.Exists(storageName);
};
export default storageAPIExists;
